var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcUnderline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 5a1 1 0 1 0-2 0v5a4 4 0 0 1-8 0V5a1 1 0 1 0-2 0v5a6 6 0 0 0 12 0zM7 18a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2z"
})));
export default SvgIcUnderline;